import type { MyBets, MyBetsState } from '../../types/myBets';

const betsLoadedSuccessfully = (state: MyBetsState, payload: MyBets): MyBetsState => ({
  ...state,
  isFetching: false,
  bets: [...state.bets, ...payload.bets],
  recentlyLoadedBets: payload.bets,
  cashoutQuotes: { ...state.cashoutQuotes, ...payload.cashoutQuotes },
  moreAvailable: payload.moreAvailable,
  numberOfMatches: payload.numberOfMatches
});

export default betsLoadedSuccessfully;
